import Vue from "vue";
import Vuex from "vuex";
//........................................ UI Modules.....................................................
import alert from "./modules/ui/alert";
import loading from "./modules/ui/loading";
import notification from "./modules/ui/notification";
import sidebar from "./modules/ui/sidebar";
import lookups from "./modules/lookups";
import security from "./modules/security";

//........................................employeesManagement...............................................
import employees from "./modules/employees";
import employeeHealth from "./modules/employeeHealth";
import employeeQualifications from "./modules/employeeQualifications";
import employeeCourses from "./modules/employeeCourses";
//.......................................employeeOperations...................................................
import employeeTransfers from "./modules/employeeTransfers";
import employeeLeaves from "./modules/employeeLeaves";
import directorsAppointments from "./modules/directorsAppointments";
import assignments from "./modules/assignments";
import promotions from "./modules/promotions";
import employeeDelegations from "./modules/employeeDelegations";
import bonuses from "./modules/bonuses";
import degreeDelegnations from "./modules/degreeDelegnations";
import notifications from "./modules/notifications";
import complaints from "./modules/complaints";
import employeesTermination from "./modules/employeeTermination";
import retirements from "./modules/retirements";
import grievances from "./modules/grievances";
import employeesCorrection from "./modules/employeesCorrection";

//........................................settings.........................................................
import administrations from "./modules/administrations";
import departments from "./modules/departments";
import units from "./modules/units";
import jobGrades from "./modules/jobGrades";
import attendanceDevices from "./modules/attendanceDevices";
import attendanceReports from "./modules/attendanceReports";
import workSchedules from "./modules/workSchedules";
import holidays from "./modules/holidays";
import organization from "./modules/organization";
import users from "./modules/users";
//........................................Lists.........................................................
import banks from "./modules/banks";
import jobGroups from "./modules/jobGroups";
import jobs from "./modules/jobs";
import universities from "./modules/universities";
import specialties from "./modules/specialties";
import localities from "./modules/localities";

import reports from "./modules/reports";
import dashboard from "./modules/dashboard";
import search from "./modules/search";
Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        // UI Modules
        alert,
        loading,
        notification,
        sidebar,
        lookups,
        security,

        // employeesManagement
        employees,
        employeeHealth,
        employeeQualifications,
        employeeCourses,

        // employeeOperations
        employeeTransfers,
        employeeLeaves,
        directorsAppointments,
        assignments,
        promotions,
        employeeDelegations,
        bonuses,
        degreeDelegnations,
        notifications,
        complaints,
        employeesTermination,
        retirements,
        grievances,
        employeesCorrection,

        // ------- settings------
        administrations,
        departments,
        jobGrades,
        users,
        units,
        attendanceDevices,
        attendanceReports,
        workSchedules,
        holidays,
        organization,

        //--------- Lists------
        banks,
        jobGroups,
        jobs,
        specialties,
        universities,
        localities,
        //--------- reports------
        reports,
        dashboard,
        search
      },
    });